export const WORK_ORDER_STATUSES = [
  "idea",
  "planned",
  "in_progress",
  "completed",
  "cancelled",
] as const;
export type WorkOrderStatus = (typeof WORK_ORDER_STATUSES)[number];

/**
 * Statuses whose requirements take part in allocation and to-order amounts
 * (architecture.md › Allocation).
 */
export const ACTIVE_WORK_ORDER_STATUSES = [
  "planned",
  "in_progress",
] as const satisfies readonly WorkOrderStatus[];
export const OPEN_WORK_ORDER_STATUSES = [
  "idea",
  "planned",
  "in_progress",
] as const satisfies readonly WorkOrderStatus[];

export const WORK_ORDER_TYPES = [
  "maintenance",
  "repair",
  "tuning",
  "restoration",
  "inspection",
  "other",
] as const;
export type WorkOrderType = (typeof WORK_ORDER_TYPES)[number];

/**
 * Where a part comes from: the vehicle maker's own (genuine), the maker's original supplier in its
 * own box (OE), or another maker (aftermarket). A part can also leave it unset.
 */
export const PART_ORIGINS = ["genuine", "oe", "aftermarket"] as const;
export type PartOrigin = (typeof PART_ORIGINS)[number];

/** An online shop, or a local dealer: a counter you visit, which can also order parts for you. */
export const SUPPLIER_KINDS = ["online", "local"] as const;
export type SupplierKind = (typeof SUPPLIER_KINDS)[number];

export const ORDER_STATUSES = [
  "draft",
  "ordered",
  "partially_received",
  "received",
  "cancelled",
] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

/** Orders whose open lines count as "on order". */
export const INCOMING_ORDER_STATUSES = [
  "ordered",
  "partially_received",
] as const satisfies readonly OrderStatus[];

export const PART_NUMBER_KINDS = ["primary", "alternative", "superseded", "aftermarket"] as const;
export type PartNumberKind = (typeof PART_NUMBER_KINDS)[number];

export const MOVEMENT_REASONS = [
  "initial",
  "adjustment",
  "order_receipt",
  "work_order_consumption",
] as const;
export type MovementReason = (typeof MOVEMENT_REASONS)[number];

export const MILEAGE_UNITS = ["km", "mi"] as const;
export type MileageUnit = (typeof MILEAGE_UNITS)[number];

export const OWNER_TYPES = ["part", "vehicle", "work_order", "template", "order"] as const;
export type OwnerType = (typeof OWNER_TYPES)[number];

export const ATTACHMENT_KINDS = ["image", "document"] as const;
export type AttachmentKind = (typeof ATTACHMENT_KINDS)[number];

export const AVAILABILITY_STATUSES = ["in_stock", "on_order", "partial", "missing"] as const;
export type AvailabilityStatus = (typeof AVAILABILITY_STATUSES)[number];

export const READINESS_STATUSES = ["ready", "waiting", "missing"] as const;
export type Readiness = (typeof READINESS_STATUSES)[number];

/** UI languages; content the app writes for the user (demo data, main groups) comes in each. */
export const LANGUAGES = ["en", "de"] as const;
export type Language = (typeof LANGUAGES)[number];
